import type { FC } from "react";

import { cn } from "../utils";
import { Icon, type MaterialSymbol } from "./icon";

export interface EmptyProps {
  icon?: MaterialSymbol;
  title: string;
  description: string;
  className?: string;
}

export const Empty: FC<EmptyProps> = ({ icon, title, description, className }) => (
  <div className={cn("px-6 py-8 space-y-2 flex flex-col items-center justify-center text-center", className)}>
    {icon && (
      <div className="size-8 rounded-full bg-primary/10 flex items-center justify-center text-xl text-primary">
        <Icon icon={icon} />
      </div>
    )}
    <div className="space-y-1">
      <h3 className={cn("text-base", icon && "text-lg")}>{title}</h3>
      <p className="text-muted-foreground text-sm">{description}</p>
    </div>
  </div>
);
